import type { Template } from "@/types";

export const PO_07_H1_V6: Template[] = [
{
    id: "po-07-h1v6-01",
    name: "PO 01 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 26, y: 230, width: 517, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 594, y: 138, width: 167, height: 286, rotation: 0, imageRotation: 0 },
            { id: "3", x: 594, y: 432, width: 167, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 138, width: 167, height: 286, rotation: 0, imageRotation: 0 },
            { id: "5", x: 769, y: 432, width: 167, height: 285, rotation: 0, imageRotation: 0 },
            { id: "6", x: 944, y: 138, width: 166, height: 286, rotation: 0, imageRotation: 0 },
            { id: "7", x: 944, y: 432, width: 166, height: 285, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-07-h1v6-02",
    name: "PO 02 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 40, y: 156, width: 484, height: 343, rotation: 0, imageRotation: 0 },
        { id: "2", x: 40, y: 507, width: 115, height: 190, rotation: 0, imageRotation: 0 },
        { id: "3", x: 163, y: 507, width: 115, height: 190, rotation: 0, imageRotation: 0 },
        { id: "4", x: 286, y: 507, width: 115, height: 190, rotation: 0, imageRotation: 0 },
        { id: "5", x: 409, y: 507, width: 115, height: 190, rotation: 0, imageRotation: 0 },
        { id: "6", x: 610, y: 221, width: 238, height: 412, rotation: 0, imageRotation: 0 },
        { id: "7", x: 856, y: 221, width: 238, height: 412, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-03",
    name: "PO 03 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 103, y: 117, width: 379, height: 295, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 103, y: 420, width: 186, height: 317, rotation: 0, imageRotation: 0 },
        { id: "3", x: 297, y: 420, width: 185, height: 317, rotation: 0, imageRotation: 0 },
        { id: "4", x: 609, y: 117, width: 352, height: 620, rotation: 0, imageRotation: 0 },
        { id: "5", x: 969, y: 117, width: 125, height: 202, rotation: 0, imageRotation: 0 },
        { id: "6", x: 969, y: 327, width: 125, height: 201, rotation: 0, imageRotation: 0 },
        { id: "7", x: 969, y: 536, width: 125, height: 201, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-04",
    name: "PO 04 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_04.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 123, y: 161, width: 157, height: 262, rotation: 0, imageRotation: 0 },
        { id: "2", x: 123, y: 431, width: 157, height: 261, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 161, width: 157, height: 262, rotation: 0, imageRotation: 0 },
        { id: "4", x: 288, y: 431, width: 157, height: 261, rotation: 0, imageRotation: 0 },
        { id: "5", x: 606, y: 161, width: 254, height: 531, rotation: 0, imageRotation: 0 },
        { id: "6", x: 868, y: 161, width: 227, height: 172, rotation: 0, imageRotation: 0 },
        { id: "7", x: 868, y: 341, width: 227, height: 351, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-05",
    name: "PO 05 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 41, y: 241, width: 486, height: 371, rotation: 0, imageRotation: 0 },
        { id: "2", x: 637, y: 106, width: 138, height: 209, rotation: 0, imageRotation: 0 },
        { id: "3", x: 637, y: 323, width: 138, height: 209, rotation: 0, imageRotation: 0 },
        { id: "4", x: 637, y: 540, width: 138, height: 208, rotation: 0, imageRotation: 0 },
        { id: "5", x: 783, y: 106, width: 138, height: 209, rotation: 0, imageRotation: 0 },
        { id: "6", x: 929, y: 106, width: 138, height: 209, rotation: 0, imageRotation: 0 },
        { id: "7", x: 783, y: 323, width: 284, height: 425, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-06",
    name: "PO 06 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 44, y: 117, width: 480, height: 351, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 44, y: 476, width: 155, height: 261, rotation: 0, imageRotation: 0 },
        { id: "3", x: 207, y: 476, width: 155, height: 261, rotation: 0, imageRotation: 0 },
        { id: "4", x: 370, y: 476, width: 154, height: 261, rotation: 0, imageRotation: 0 },
        { id: "5", x: 610, y: 145, width: 320, height: 535, rotation: 0, imageRotation: 0 },
        { id: "6", x: 938, y: 145, width: 157, height: 264, rotation: 0, imageRotation: 0 },
        { id: "7", x: 938, y: 417, width: 157, height: 263, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-07",
    name: "PO 07 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 110, y: 50, width: 223, height: 373, rotation: 0, imageRotation: 0 },
        { id: "2", x: 341, y: 50, width: 223, height: 373, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 50, width: 223, height: 373, rotation: 0, imageRotation: 0 },
        { id: "4", x: 803, y: 50, width: 223, height: 373, rotation: 0, imageRotation: 0 },
        { id: "5", x: 110, y: 431, width: 223, height: 373, rotation: 0, imageRotation: 0 },       
        { id: "6", x: 341, y: 431, width: 454, height: 373, rotation: 0, imageRotation: 0 },
        { id: "7", x: 803, y: 431, width: 223, height: 373, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-08",
    name: "PO 08 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_08.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 0, y: 166, width: 143, height: 257, rotation: 0, imageRotation: 0 },
        { id: "2", x: 151, y: 166, width: 143, height: 257, rotation: 0, imageRotation: 0 },
        { id: "3", x: 302, y: 166, width: 143, height: 257, rotation: 0, imageRotation: 0 },
        { id: "4", x: 0, y: 431, width: 143, height: 257, rotation: 0, imageRotation: 0 },
        { id: "5", x: 151, y: 431, width: 143, height: 257, rotation: 0, imageRotation: 0 },
        { id: "6", x: 302, y: 431, width: 143, height: 257, rotation: 0, imageRotation: 0 },
        { id: "7", x: 453, y: 166, width: 685, height: 522, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-09",
    name: "PO 09 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_09.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 0, width: 523, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 621, y: 180, width: 462, height: 339, rotation: 0, imageRotation: 0 },
        { id: "3", x: 621, y: 527, width: 86, height: 147, rotation: 0, imageRotation: 0 },
        { id: "4", x: 715, y: 527, width: 86, height: 147, rotation: 0, imageRotation: 0 },
        { id: "5", x: 809, y: 527, width: 86, height: 147, rotation: 0, imageRotation: 0 },
        { id: "6", x: 903, y: 527, width: 86, height: 147, rotation: 0, imageRotation: 0 },
        { id: "7", x: 997, y: 527, width: 86, height: 147, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h1v6-10",
    name: "PO 10 - H1V6",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h1_v6_10.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 49, y: 117, width: 121, height: 201, rotation: 0, imageRotation: 0 },
        { id: "2", x: 49, y: 326, width: 121, height: 201, rotation: 0, imageRotation: 0 },
        { id: "3", x: 49, y: 535, width: 121, height: 200, rotation: 0, imageRotation: 0 },
        { id: "4", x: 178, y: 117, width: 779, height: 618, rotation: 0, imageRotation: 0 },
        { id: "5", x: 965, y: 117, width: 122, height: 201, rotation: 0, imageRotation: 0 },
        { id: "6", x: 965, y: 326, width: 122, height: 201, rotation: 0, imageRotation: 0 },
        { id: "7", x: 965, y: 535, width: 122, height: 200, rotation: 0, imageRotation: 0 }
    ],
}
];